import React from 'react';
import { IdelinkModuleTheme } from '../../../configs/IdeLinkTheme';

import { ProductOfferType } from './ProductOfferType';
export interface OffersConfig {
    type: ProductOfferType;
    showCreateTunable: boolean; //! MIDAS
    showSyncPackagedOrders: boolean; //! MIDAS
    disableImportExportProducts: boolean;

    useDeliveryWeek: boolean; //! FLUIZY
    canDeleteAllProduct: boolean; //! FLUIZY
    showPromoOdr: boolean; //! FLUIZY

    disableResultStats?: boolean;
}

export interface OffersModuleConfig extends OffersConfig {
    readonly createUrl: string;
    readonly listUrl: string;
    readonly editUrl: (id: string) => string;
    readonly i18nKeyPrefix: string;
    readonly apiResourceName: string;
    readonly listCustomResourceName?: string;

    readonly hidePromoPrice?: boolean;

    readonly theme: IdelinkModuleTheme;
}

export const DefaultOffersConfig: OffersConfig = {
    type: ProductOfferType.PRODUCT_TYPE_MULTI,

    // list
    showCreateTunable: false, // used to show/hide the button, as well as determine label type in 'PackagedOrderType'
    showSyncPackagedOrders: false,

    disableImportExportProducts: false,
    disableResultStats: false,

    useDeliveryWeek: false,
    canDeleteAllProduct: false, //* true on Fluizy configs
    showPromoOdr: false, //* true on Fluizy configs
};

export const DefaultOffersModuleConfig: OffersModuleConfig = {
    ...DefaultOffersConfig,
    createUrl: '',
    listUrl: '',
    editUrl: (id: string) => '',
    i18nKeyPrefix: '',
    apiResourceName: '',

    hidePromoPrice: false,
    theme: {},
};

export const OffersModuleContext =
    React.createContext<OffersModuleConfig>(DefaultOffersModuleConfig);
export const useOffersModuleConfig = () => React.useContext(OffersModuleContext);

export const OffersContext = React.createContext<OffersConfig>(DefaultOffersConfig);
export const useOffersConfig = () => React.useContext(OffersContext);
